import { removeLastComma } from './RemoveComma';

export const createUrl = (arr) => {
    let tempurl = '';
    arr.forEach((val) => {
        tempurl += `${val},`;
    });
    return removeLastComma(tempurl);
};
